module.exports = {
  charge_noSelection: 'Please select charges first',
  createReceivableBill: 'Create Receivable Bill',
  createPayableBill: 'Create Payable Bill',
  finance_inputBusinessNumber: 'Please input business number',
  finance_query: 'Query',
  finance_view: 'View',
  finance_returnQuery: 'Return Query',
  finance_batchAudit: 'Batch Audit',
  finance_lockTheBill: 'Lock The Bill',
  finance_accrue: 'Accrue',
  finance_businessCommission: 'business Commission',
  finance_cancelAccrue: 'Cancel Accrue',
  finance_print: 'Print',
  finance_audit: 'Audit',
  finance_cancelTheAudit: 'Cancel The Audit',
  finance_chargesAudit: 'Charges Audit',
  finance_cancelTheChargesAudit: 'Cancel The Charges Audit',
  finance_printTheProfit: 'Print The Profit',
  finance_editFinancialDate: 'Edit Financial Date',
  finance_businessAdjustment: 'Business Adjustment',
  finance_editChargeFinancialDate: 'Edit Charge Financial Date',
  finance_basic: 'Basic',
  finance_booking: 'Booking',
  finance_charges: 'Charges',
  finance_domesticBill: 'Domestic Bill',
  finance_internationalBill: 'International Bill',
  finance_collectAndPrepaid: 'Collect And Prepaid',
  finance_fileHistory: 'File History',
  finance_exportExcelAll: 'ExportExcelAll',
  finance_updateBusinessDate: 'Edit Business Date',
  finance_log: 'Log',
  finance_allowChange: 'Allow Change',
  finance_checkChange: 'Check Change',
  finance_batchCheckChange: 'Batch Check Change',
  finance_revokeChangeCommit: 'Revoke Change Commit',
  charge_receivables: 'Receivables',
  charge_equivalent: 'Equivalent',
  charge_inviteToConfirmTheCharges: 'Invite To Confirm The Charges',
  charge_newAdjustment: 'New Adjustment',
  charge_editAdjustment: 'Edit Adjustment',
  charge_deleteAdjustment: 'Delete Adjustment',
  charge_writeOffList: 'Clearance List',
  charge_chargesReject: 'Reject',
  charge_chargeItem: 'Charge Item',
  charge_settleAccountsTo: 'Settle Accounts To',
  charge_invoiceHeader: 'Invoice Header',
  charge_somesticOrInternational: 'Domestic Or Overseas',
  charge_drawABillOrNot: 'Draw A Bill Or Not',
  charge_currency: 'Currency',
  charge_localCurrency: 'Local Currency',
  charge_conversionRMB: 'Conversion of Renminbi',
  charge_exchangeRate: 'Exchange Rate',
  charge_unit: 'Unit',
  charge_amount: 'Quantity',
  charge_unitPrice: 'Unit-Price',
  charge_taxIncludedPrice: 'Tax Included Price',
  charge_taxExcludedPrice: 'Tax Excluded Price',
  charge_taxRate: 'Tax Rate',
  charge_whtTaxRate: 'WHT tax Rate',
  charge_payables: 'Payables',
  charge_controlled: 'Controlled',
  charge_cancelControlled: 'Cancel Controlled',
  charge_taxAmount: 'Tax amount',
  charge_whtTaxAmount: 'WHT tax amount',
  charge_whtTaxLocalAmount: 'WHT tax amount(local currency)',
  charge_notWhtAmount: 'Excluding WHT amount',
  charge_remarks: 'Remarks',
  charge_contactPerson: 'Contact Person',
  charge_relatedBLNo: 'Related B/L No',
  charge_relatedContainerNo: 'Associated box number',
  charge_freightCollectOrPrepaid: 'Freight Term',
  charge_status: 'Status',
  charge_confirmOrNot: 'Confirm or not',
  charge_billNo: 'Bill No',
  charge_agent_billNo: 'Agent Shared Bill No',
  charge_containerNo: 'Container No',
  charge_invoiceNo: 'Invoice No',
  charge_invoiceDate: 'Invoice Date',
  charge_agentBillNo: 'Agent Bill No',
  charge_theAmountOfWriteOffs: 'Clearance Amount',
  charge_writeOffDate: 'Clearance Date',
  charge_financialDate: 'Financial Date',
  charge_businessNumber: 'Business Number',
  charge_creator: 'Creator',
  charge_createTime: 'Create Time',
  charge_editor: 'Editor',
  charge_editTime: 'Edit Time',
  charge_paymentApplicationNo: 'Payment Application No',
  charge_profit: 'Profit',
  charge_profitAll: 'Profit All',
  charge_locked_status: 'Locked Status',
  // charge_equivalent: 'Equivalent',
  charge_estimateRemarks: 'Estimate Remarks',
  charge_showRedCharges: 'Show Red Charges',
  charge_auditor: 'Auditor',
  charge_estimate: 'Estimate',
  charge_add: 'Add',
  charge_copy: 'Copy',
  charge_delete: 'Delete',
  charge_edit: 'edit',
  charge_chargesAudit: 'Charges Audit',
  charge_cancelTheAudit: 'cancel The Audit',
  charge_showCommonCharge: 'Show Common Charges',
  charge_showSpecialCharge: 'Show Special Charges',
  charge_showBusinessSpecialCharge: 'Show Business Special Charges',
  charge_businessSpecialFlag: 'Biz Special',
  charge_sp1: 'Tariff No',
  charge_sp2: 'Click and copy tariff No',
  charge_sp3: 'Add by service',
  charge_sp4: 'Refresh exchange rate',
  charge_sp5: 'Copy receipt charge',
  charge_sp6: 'Copy AP',
  charge_sp7: 'Charge Plan',
  charge_sp8: 'Tariff',
  charge_sp9: 'Unsubmit',
  charge_sp10: 'Submit',
  charge_sp11: 'Split the charge',
  charge_sp12: 'Show HBL charge',
  charge_sp13: 'Service item',
  charge_copyCost: 'Copy AR',
  charge_copyCharge: 'Historical Charge',
  charge_payReceiveDate: 'PayReceiveDate',
  charge_actualAmountNo: 'ActualAmountNo',
  charge_newChange: 'Add amendment fee',
  charge_editChange: 'Edit amendment fee',
  charge_deleteChange: 'Delete Change',
  charge_shared: 'Shared Charge',
  charge_showSharedCharges: 'Show Shared Charge',
  charge_newSpecial: 'New Special',
  charge_newBusinessSpecial: 'New Business Special',
  charge_editSpecial: 'Edit Special',
  charge_editBusinessSpecial: 'Edit Business Special',
  charge_unitPriceIncludeTax: 'Does unit price include tax',
  domestic_showAllBill: 'Show All Billings',
  domestic_commissionedChargesOnly: 'Show this Commissioned charges only',
  domestic_newReceivables: 'New Receivables',
  domestic_newPayables: 'New Payables',
  domestic_edit: 'Edit',
  domestic_delete: 'Delete',
  domestic_view: 'View',
  domestic_confirm: 'Confirm',
  domestic_cancelConfirm: 'Cancel Confirmation',
  domestic_billNo: 'Bill No',
  domestic_settleAccountTto: 'Settle Accounts To',
  domestic_settlementAgent: 'Settlement Agent',
  domestic_invoiceHeader: 'Invoice Header',
  domestic_currency: 'Currency',
  domestic_chargeAmount: 'Charge Amount',
  domestic_amount: 'Amount',
  domestic_totalCurrency: 'Total Currency',
  domestic_revenueAndExpenditureType: 'Revenue And Expenditure Type',
  domestic_confirmationStatus: 'Confirm Status',
  domestic_invoicingStatus: 'Invoicing Status',
  domestic_writeOffStatus: 'Clearance Status',
  domestic_revenueOrExpenditure: 'Revenue Or Expenditure',
  domestic_chargeItem: 'Charge Item',
  domestic_unit: 'Unit',
  // domestic_amount: 'Amount',
  domestic_unitPrice: 'Unit-Price',
  domestic_taxIncludedPrice: 'Tax Included Price',
  domestic_taxExcludedPrice: 'Tax Excluded Price',
  domestic_taxRate: 'Tax Rate',
  domestic_taxAmount: 'Tax Amount',
  domestic_remarks: 'Remarks',
  domestic_billingGroupNo: 'Billing Group No',
  domestic_billingBranchId: 'Billing CMP',
  international_showAllBilling: 'show All Billings',
  international_commissionedChargesOnly: 'Commissioned Charges Only',
  international_add: 'Add',
  international_edit: 'Edit',
  international_delete: 'Delete',
  international_audit: 'Audit',
  international_invalid: 'Invalid',
  international_agentProfitShareBillNo: 'Agent Profit Share Bill No',
  international_editAgentBillNo: 'Edit Agent Bill No',
  international_printAllAgentProfitShareBillNo: 'Print All Agent Profit Share Bill No',
  international_billNo: 'Bill No',
  international_agentBillNo: 'Agent BillNo',
  international_revenueAndExpenditureType: 'Revenue And Expenditure Type',
  international_settleAccountTo: 'Settle Account To',
  international_settlementAgent: 'Settlement Agent',
  international_currency: 'Currency',
  international_chargeAmount: 'Charge Amount',
  international_amount: 'Amount',
  international_status: 'Status',
  international_billType: 'Bill Type',
  international_invoicingStatus: 'Invoicing Status',
  international_writeOffStatus: 'Clearance Status',
  international_billDtae: 'Bill Date',
  international_creator: 'Creator',
  international_businessNumber: 'Business Number',
  international_billingGroupNo: 'Billing Group No',
  international_revenueOrExpenditure: 'Revenue Or Expenditure',
  international_chargeItem: 'Charge Item',
  international_taxIncludedPrice: 'Tax Included Price',
  international_taxExcludedPrice: 'Tax Excluded Price',
  international_taxRate: 'Tax Rate',
  international_taxAmount: 'Tax Amount',
  international_unit: 'Unit',
  // international_amount: 'Amount',
  international_unitPrice: 'Unit-Price',
  international_remarks: 'Remarks',
  adChargeInfo_prepaid: 'Prepaid',
  adChargeInfo_print: 'Print',
  adChargeInfo_newAdjustment: 'New Adjustment',
  adChargeInfo_editAdjustment: 'Edit Adjustment',
  adChargeInfo_deleteAdjustment: 'Delete Adjustment',
  adChargeInfo_addBoth: 'Add Both',
  adChargeInfo_add: 'Add',
  adChargeInfo_delete: 'Delete',
  adChargeInfo_chargeItem: 'Charge Item',
  adChargeInfo_settleAccountsTo: 'Settle Accounts To',
  adChargeInfo_domesticOrInternational: 'Domestic Or Overseas',
  adChargeInfo_currency: 'Currency',
  adChargeInfo_unit: 'Unit',
  adChargeInfo_quantity: 'Quantity',
  adChargeInfo_unitPrice: 'Unit-Price',
  adChargeInfo_exchangeRate: 'Exchange Rate',
  adChargeInfo_amount: 'Amount',
  adChargeInfo_remarks: 'Remarks',
  adChargeInfo_billNo: 'Bill No',
  adChargeInfo_taxNo: 'Tax No',
  arChargeInfo_theAmountOfWriteOffs: 'Amount Received',
  apChargeInfo_theAmountOfWriteOffs: 'Amount Paid',
  adChargeInfo_collect: 'Collect',
  adChargeInfo_submitCharge: 'Submit Charge',
  adChargeInfo_cancelSubmit: 'Cancel Submit',
  adChargeInfo_status: 'Status',
  adChargeInfo_paymentApplicationNo: 'Payment Application No',
  international_forceDelete: 'Force delete',
  return: 'return',
  Confirm: 'Confirm',
  Cancel: 'Cancel',
  accrualDate: 'accrualDate',
  adjustmentItem: 'adjustment Item',
  adjustmentValue: 'adjustment Value',
  charge_ProvisionedDate: 'Provisioned Date',
  charge_specialUpdate: 'Adjustment of special expenses',
  charge_settleDepartmentPrefix: 'settleDepartment',
  charge_paymentApplicationDateCreated: 'Payment Application Date Created ',
  charge_SapStatus: 'SAP Status',
  finance_ChargeCommit: 'Change order submission',
  separateAllocation: 'Separate Allocation',
  allocationType: 'Allocation Type',
  costSharingValue: 'Cost Sharing Value',
  modifyField: 'Modify Field',
  operationContent: 'Operation content',
  statusAfterOperation: 'Status after operation',
  routeLeader: 'Route Leader',
  selectAdjustmentItem: 'Please select adjustment item',
  businessInfoAdjustedSuccess: 'Business information adjusted successfully',
  apportionedTax: 'Apportioned Tax',
  charge_asyncCharges: 'Cost Synchronization',
  charge_asyncChargeRecords: 'Cost Synchronization Record',
  lockBusinessSuccess: 'The order locking operation succeeded',
  AccountVerifyBusinessSuccess: 'Audit operation succeeded',
  AccrualSucceeded: 'Accrual succeeded',
  charge_asyncChargesToImportJob: 'Synchronize To Import Business',
  charge_syncChargesConfirmStatus: 'Synchronous charge confirmation',
  charge_cancelSyncChargesConfirmStatus: 'Cancel synchronous charge confirmation',
  charge_syncChargesToSI: 'Synchronization of export to import expenses',
  charge_cancelSyncChargesToSI: 'cancel synchronization of export to import expenses',
  charge_syncPayable: 'Synchronize Payable Charge',
  charge_isSync: 'Is Synchronized',
  charge_paymentAmount: 'EAS Payment Amount',
  expenseSharingReceipt: 'Expense sharing receipt',
  correspondingAllocationBusiness: 'Corresponding allocation business',
  allocateRelatedBusinesses: 'Allocate related businesses',
  BusinessSyncModifyBusinessDate: 'The export business will synchronously modify the business date',
  ImportBusinessSyncModifyBusinessDate: 'The import business will synchronously modify the business date',
  ExportBusinessItemCannotEmpty: 'This item of export business cannot be empty',
  ImportBusinessItemCannotEmpty: 'This item of import business cannot be empty',
  LandTransportationBusinessItemCannotEmpty: 'This item of land transportation business cannot be empty',
  synchronizationFeesToBeProcessed: ' synchronization fees to be processed',
  markAsRead: 'Mark as read',
  fail: 'Fail',
  applyRecallCharge: 'apply recall charge',
  recallState: 'recall state',
  recallCause: 'recall cause',
  youCanOnlyOperateOnConfirmedCharges: 'You can only operate on confirmed charges',
  thereAreCostsThatHaveBeenWithdrawn: 'There are costs that have been withdrawn',
  theFeeHasEnteredTheSettlementProcess: 'The fee has entered the settlement process',
  PleaseSeparateTheFeesForConfirmationAndWithdrawal: 'Please separate the fees for confirmation and withdrawal',
  receivablePayable: 'receivable/payable',
  currency: 'Currency',
  sender: 'Sender',
  receiver: 'Receiver',
  syncProgress: 'Synchronization Progress',
  processingStatus: 'Processing status',
  sendingTime: 'Sending time',
  auditOperationTime: 'Audit operation time',
  pending: 'Pending',
  alreadyRead: 'Already read',
  notRead: 'Not read',
  businessHasBeenSubmitted: 'Business has been submitted, unable to pass and add fees. If necessary, please contact the business supervisor to cancel the submission.',
  selectBeConfirmedChargeByUs: 'Please select the expense to be confirmed by us',
  selectRejectedChargeByOppositeParty: 'Please select the expense rejected by the opposite party',
  pleaseSaveTheCurrentPageFirst: 'Please save the current page first',
  commissionAmount: 'Commission Amount',
  charge_writeOffDate_ar: 'Received Date',
  charge_writeOffDate_ap: 'Paid Date',
  GenerateVoucher: 'Has voucher been generated',
  CurrencyAccountsReceivable: 'Currency accounts payable:',
  CurrencyAccountsPayable: 'Currency accounts payable:',
  today: 'Today',
  thisMonthEnd: 'This month end',
  previousMonthEnd: 'Previous month end',
  IssueMonthOfYear: 'Issue {1} of {0}',
  QMonthYear: 'Q{1} {0}',
  XYear: '{0} year',
  SongtiSerif: 'Songti, serif',
  TrialBalance: 'Trial Balance',
  BalanceSheetWithContacts: 'Balance Sheet with Contacts',
  StatementOfAccountWithContacts: 'Statement of Account with Contacts',
  SubsidiaryLedger: 'Subsidiary Ledger',
  GeneralLedger: 'General Ledger',
  Receive: 'Receive',
  Pay: 'Pay',
  Transfer: 'Transfer',
  ForeignCurrencyRevaluation: 'Foreign Currency Revaluation',
  RetainedEarnings: 'Retained Earnings',
  Billion: 'Billion',
  Thousand: 'Thousand',
  Hundred: 'Hundred',
  Ten: 'Ten',
  TenThousand: 'Ten Thousand',
  Yuan: 'Yuan',
  Dime: 'Dime',
  Cent: 'Cent',
  FailedObtainCurrentFiscalPeriod: 'Failed to obtain current fiscal period!',
  Total: 'Total',
  Quantity: 'Quantity:',
  UnitPrice: 'Unit Price:',
  ForeignCurrency: 'Foreign Currency:',
  UnbalancedDebitAndCreditEntry: 'Unbalanced debit and credit entry!',
  ThisVoucherPleaseEditInModule: 'This voucher is a business voucher\nPlease edit in the "Generate Voucher" module',
  ForeignCurrencyCannotBeEmpty: 'Foreign Currency cannot be empty',
  ClientItemCannotBeEmpty: 'Client for subsidiary item cannot be empty',
  SupplierItemCannotBeEmpty: 'Supplier for subsidiary item cannot be empty',
  StaffItemCannotBeEmpty: 'Staff for subsidiary item cannot be empty',
  ProjectItemCannotBeEmpty: 'Project for subsidiary item cannot be empty',
  DepartmentItemCannotBeEmpty: 'Department for subsidiary item cannot be empty',
  Client: 'Client',
  Supplier: 'Supplier',
  Department: 'Department',
  Staff: 'Staff',
  Project: 'Project',
  Currency: 'Currency:',
  Amount: 'Amount:',
  ExchangeRate: 'Exchange Rate:',
  All: 'All',
  Yes: 'Yes',
  No: 'No',
  Year: 'Year',
  Period: 'Period',
  PleaseSelectVoucherRange: 'Please select voucher range',
  Assets: 'Assets',
  Liabilities: 'Liabilities',
  Equity: 'Equity',
  Cost: 'Cost',
  ProfitAndLoss: 'Profit and Loss',
  ClientSupplier: 'Client/Supplier',
  BalanceInRMB: 'Balance in RMB',
  UnmatchedClientOrSupplier: 'Unmatched client or supplier',
  AddAssetAccount: 'Add Asset Account',
  Add: 'Add',
  Edit: 'Edit',
  Delete: 'Delete',
  AddCashFlowItem: 'Add Cash Flow Item',
  ImportSucceeded: 'Import succeeded',
  DesignSubaccounts: 'Design Subaccounts',
  NeedToExport: 'Need to export',
  NoExportNeeded: 'No export needed',
  SeparatorSettings: 'Separator settings',
  ExportSeparator: 'Export separator',
  Separator: 'Separator:',
  PleaseFinancialYearForReport: 'Please enter the financial year for initializing report.',
  RepeatingDataLossPleaseCaution: 'Repeating initialization may cause data loss, please use with caution.',
  InitializationPleaseCheckAccountSettings: 'Initialization succeeded, please check account settings.',
  InitializationPleaseCheckTheReport: 'Initialization succeeded, please check the report.',
  DetailedEntryRulesConfiguration: 'Detailed entry rules configuration',
  FeeWillBeDeleted: 'Note: {0} fee will be deleted',
  AccountNotFound: 'Account not found',
  Quarter: 'Quarter',
  AccountingVoucher: 'Accounting Voucher',
  StatusUnknown: 'Status unknown',
  N0Year0Period: '{0} year, {1} period',
  SyncCloudSucceededXFailedX: 'Synchronization of cloud and starry sky succeeded {0} times, failed {1} times',
  SyncExceptionReason: 'Reason for synchronization abnormality',
  SyncCloudStarrySky: 'Synchronous Cloud Starry Sky',
  SyncFeeCannotSyncAgain: 'Synchronized fees cannot be synchronized again!',
  DisplayTransactions: 'Display transactions',
  EnterBusinessNumberBeforeQuery: 'Please enter the business number before querying',
  SelectNewEncodingType: 'Select new encoding type',
  SelectMatchingPartnerFieldType: 'Select matching partner field type',
  NewEncodingType: 'New encoding type:',
  CustomerCode: 'Customer Code',
  SupplierCode: 'Supplier Code',
  AtLeastOneCustomerAndSupplierCode: 'Check at least one customer code and supplier code',
  MatchPartnerFieldTypes: 'Match Partner Field Types:',
  PartnersCode: 'Partners code',
  PartnersNumber: 'Partners number',
  PartnersChineseName: 'Partners chinese name',
  ImportCustomerAndProviderCode: 'Are you sure to import [{0}] as the customer code and supplier code of this A/C set partner?',
  ImportCustomerCode: 'Are you sure to import [{0}] as the customer code for this A/C set partner?',
  ImportProviderCode: 'Are you sure to import [{0}] as the supplier code for this A/C set partner?',
  ImportCodePenddingTip: 'Importing customer/supplier codes<br>Leaving the current page will not affect data import, and you will be notified after the import is completed.',
  ModifyExpirationDate: 'Modify expiration date',
  ModifyChargeExpirationDate: 'Modify fee expiration date',
  RemoveCountFee: 'Please remove the calculated fees',
  ChargeHqCurrency: 'HQ Currency',
  ChargeHqRate: 'HQ Rate',
  CostType: 'Cost Type',
  HideForeignCurrencyProfitLoss: 'Do not display foreign currency profit and loss carryover',
  GpExplain: 'GP Explain',
  Peer: 'Is the commissioning unit in the same industry',
  ProfitRate: 'Profit Rate',
  ArRowsAndApRows: 'AR Rows / AP Rows',
  ArIncludeAp: 'AR Include AP',
  Allocation: 'Allocation',
  LclTicketsCanNotAudit: 'LCL tickets cannot be reviewed separately, please review the main ticket.',
  SelectedDataJobSubmitNotAllowAudit: 'The selected data contains business submitters who are the same as the current reviewer and cannot be reviewed. Please check!',
  SelectedDataJobSubmitNotAllowCancelAudit: 'The selected data has the same submitter as the current reviewer, and cancellation of the review is not allowed. Please check!',
  SelectedDataChargeByNotAllowCancelAudit: 'The selected data contains the same person who submitted the change order as the current approver, which does not allow approval. Please check!',
  JobSubmitNotAllowAudit: 'The business submitter is the same as the current reviewer and cannot be reviewed!',
  JobSubmitNotAllowCancelAudit: 'The business submitter is the same as the current reviewer, and cancellation of the review is not allowed!',
  JobSubmitNotAllowCancelChangeOrder: 'The business submitter and the current reviewer are the same, and it is not allowed to change the order!',
  ChargeSubmitNotAllowAudit: 'The fee submitter is the same as the current reviewer, and approval is not allowed!',
  ChargeSubmitNotAllowCancelAudit: 'The fee submitter is the same as the current reviewer, and it is not allowed to cancel the fee review!',
  ChargeSubmitNotAllowCancelChangeOrder: 'The fee submitter is the same as the current reviewer, and it is not allowed to change the order for review!',
  AdditionalCostRemarks: 'Append additional fee note',
  AdditionalCostRemarksContent: 'Additional fee note content',
  JobSubmitNotAllowCancelAdjustCosts: 'The business submitter and the current reviewer are the same, and it is not allowed to adjust the fees!'
}
